<template>
  <div class="shop-search-h5_style">
    <el-input
      :placeholder="$t('寻找餐厅和美食')"
      v-model="inputValue"
      input-on-composing
      class="input-search_style_reset-h5"
      clearable
      prefix-icon="icon-outline_search"
      ref="outIptVal"
      @focus="openH5SearchShop"
    ></el-input>
    <el-drawer
      :visible.sync="h5SearchShopVisible"
      direction="btt"
      size="100%"
      :show-close="false"
      :withHeader="false"
    >
      <div class="h5-mobile_shop_search">
        <input type="text" readonly class="d-hide-input">
        <div class="search-header flex">
          <div class="arrow-left flex" @click="closeH5SearchShop">
            <i class="icon-linetype_back_iOS"></i>
          </div>
          <div class="header-input flex">
            <el-input
              :placeholder="$t('寻找餐厅和美食')"
              v-model="inputValue"
              clearable
              class="input-search_style_reset-h5"
              prefix-icon="icon-outline_search"
              ref="inputSearch"
              @keyup.enter.native="inputChange"
            >
            </el-input>
          </div>
        </div>
        <div class="content-list">
          <ListItem
            v-if="inputValue"
            :loading="loading"
            :words="words"
            :isH5="isH5"
            @handleSelect="handleSelect"
            :input_word="inputValue"
          ></ListItem>
          <div class="d-history-text" v-if="!inputValue" v-r-loading="loading">
            <div class="recommend-content">
              <template v-if="!noHistoryAndRecommendText">
                <HistoryText
                  :historySearchText="historySearchText"
                  @openDelHistoryDialog="openDelHistoryDialog"
                  @handleSelect="handleSelect"
                ></HistoryText>
                <HotRecommend
                  :recommend="recommend"
                  @handleSelect="handleSelect"
                ></HotRecommend>
              </template>
              <!-- <div v-else-if="loading"></div> -->
              <!-- <NoList v-else-if="noHistoryAndRecommendText"></NoList> -->
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { stopScroll, openScroll } from '@/utils/baseUtil';

import HistoryText from './historyText.vue';
import HotRecommend from './hotRecommend.vue';
import ListItem from './listItem.vue';
// import NoList from '../NoList';
export default {
  name: 'ShopSearchH5',
  components: {
    HistoryText,
    HotRecommend,
    ListItem,
    // NoList,
  },
  props: {
    isH5: Boolean,
    inputVal: {
      type: String,
      default: '',
      required: true,
    },
    historySearchText: {
      type: Array,
      default: () => [],
      required: false,
    },
    recommend: {
      type: Array,
      default: () => [],
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
    words: {
      type: Array,
      default: () => [],
      required: false,
    },
    noHistoryAndRecommendText: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    '$route.query.q'(newV) {
      if(newV) {
        this.inputValue = decodeURIComponent(decodeURIComponent(newV));
      }else {
        this.inputValue = '';
      }
    },
    inputValue(newV) {
      this.$emit('update:inputVal', newV);
      if (!newV) {
        this.$emit('focus-event');
        this.$emit('clear-words');
      }
    },
  },
  data() {
    return {
      inputValue: this.inputVal,
      h5SearchShopVisible: false,
    };
  },
  methods: {
    inputChange() {
      if(!this.inputValue) return
      this.h5SearchShopVisible = false;
      this.$emit('inputChange');
    },
    openH5SearchShop() {
      if (this.inputValue) {
        this.$emit('clear-words');
        this.$emit('get-search-suggestion');
      } else {
        this.$emit('focus-event');
      }
      this.h5SearchShopVisible = true;
      this.$refs.outIptVal.blur();
    },
    closeH5SearchShop() {
      this.h5SearchShopVisible = false;
    },
    openDelHistoryDialog() {
      this.$emit('openDelHistoryDialog');
    },
    handleSelect(item, q, index) {
      this.h5SearchShopVisible = false;
      this.inputValue = q
      this.$emit('handleSelect', item, q, index);
    },
  },
};
</script>
<style lang="scss">
.shop-search-h5_style {
  display: flex;
  .h5-mobile_shop_search {
    background: #f5f5f7;
    overflow: hidden;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .el-loading-mask {
      background: rgba(#f5f5f7, 0.9);
    }
    .search-header {
      height: rem(120);
      padding: 0 rem(24);
      align-items: center;
      .arrow-left {
        align-items: center;
        width: rem(64);
        height: rem(72);
        margin-right: rem(16);
        cursor: pointer;
        i {
          font-size: rem(36);
        }
      }
    }
    .header-input {
      flex: 1;
      input {
        font-family: 'Aspira Light';
        background-color: #e3e3e6;
        border-radius: rem(8);
        font-weight: 200;
      }
    }
    .content-list {
      flex: 1;
      display: flex;
      overflow: auto;
    }
    .d-history-text {
      flex: 1;
      height: auto;
      margin: 0;
      padding: 0 rem(24);
      .history-recommend {
        margin-bottom: rem(60);
      }
    }
    .d-pc-shop_search-content {
      flex: 1;
      height: auto;
      padding: 0 rem(24);
      padding-bottom: rem(30);
      .shop-name {
        background: #ffffff;
      }
      .shop-name:first-child {
        border-radius: rem(12) rem(12) 0 0;
      }
      .shop-name:last-child {
        border-radius: 0 0 rem(12) rem(12);
      }
      .no-list {
        margin-top: rem(-200) !important ;
      }
    }
    .recommend-content {
      padding-top: rem(57);
      .no-list {
        margin-top: rem(100) !important;
      }
    }
  }
}
</style>
